<template>
    <Splide :has-track="false" class="" :options="options" @splide:moved="onSlideChange" ref="splide">
        <SplideTrack>
            <SplideSlide
                v-for="(image, index) in images" :key="image.src"
                class="rounded-2xl overflow-hidden"
            >
                <img :src="image.src" :alt="image.caption || 'Gallery image'" class="w-full h-full max-h-[664px] object-cover" />
            </SplideSlide>
        </SplideTrack>

        <div class="container relative">
            <!-- Constrain captions and controls to match the actual middle image width -->
            <div class="mx-auto px-4 2xl:px-0 mt-4" :style="{ maxWidth: middleImageWidth + 'px' }">
                <div class="flex flex-wrap items-start justify-between gap-4">
                    <figcaption v-if="currentCaption" class="caption text-md text-black font-normal flex-1 min-w-0 text-left">
                        <p>{{ currentCaption }}</p>
                        <br>
                    </figcaption>

                    <div v-else class="flex-1"></div>
                    
                    <div class="splide__arrows hidden md:flex gap-2 flex-shrink-0">
                        <button class="splide__arrow--prev w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                            <svg class="relative -left-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                            </svg>
                        </button>

                        <button class="splide__arrow--next w-11 h-11 flex justify-center items-center bg-primary hover:bg-primary-tone rounded-full">
                            <svg class="relative -right-px" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" fill="#3B3C4A"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Splide>
</template>
<script>
import {defineComponent} from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';

export default defineComponent({
    components: {
        Splide,
        SplideSlide,
        SplideTrack,
    },
    data() {
        return {
            currentSlideIndex: 0,
            middleImageWidth: 1145, // Default fallback
            options: {
                type: 'loop',
                perPage: 1,
                focus: 'center',
                updateOnMove: true,
                arrows: true,
                pagination: false,
                padding: '20%',
                gap: '1rem',
                breakpoints: {
                    1440: {
                        padding: '10%'
                    }
                },
            },
        }
    },
    computed: {
        images() {
            let images = window.capes.blog_gallery ?? false

            if (!images) {
                return false
            }

            return images.map((image) => {
                return {
                    src: `${image.url}`,
                    thumb: `${image.url}`,
                    caption: image.caption,
                    data: image,
                }
            })
        },
        currentCaption() {
            if (!this.images || this.images.length === 0) {
                return null;
            }
            const currentImage = this.images[this.currentSlideIndex];
            return currentImage && currentImage.caption ? currentImage.caption : null;
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.measureMiddleImage();
            }, 100);
        });
        window.addEventListener('resize', this.measureMiddleImage);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.measureMiddleImage);
    },
    methods: {
        onSlideChange(splide, newIndex) {
            this.currentSlideIndex = newIndex;
        },
        measureMiddleImage() {
            this.$nextTick(() => {
                // Find the active/center slide image
                const activeSlide = document.querySelector('.splide__slide.is-active img, .splide__slide.is-visible img');
                
                if (activeSlide) {
                    this.middleImageWidth = activeSlide.offsetWidth;
                } else {
                    // Fallback: try to find any slide image
                    const anySlideImage = document.querySelector('.splide__slide img');
                    if (anySlideImage) {
                        this.middleImageWidth = anySlideImage.offsetWidth;
                    }
                }
            });
        }
    }
})
</script>
